@for (itemMedicalCare of medicalCare; track itemMedicalCare; let index = $index) {
  <cdk-accordion-item
    #accordionItemModule="cdkAccordionItem" class="profile-register-accordion-item" role="button" tabindex="0"
    [attr.id]="'accordion-header-' + index" [attr.aria-expanded]="accordionItemModule.expanded"
    [attr.aria-controls]="'accordion-body-' + index">
    <div [ngClass]="{'profile-register-accordion-item-header-expanded': accordionItemModule.expanded}"
      class="profile-register-accordion-item-header" (click)="accordionItemModule.toggle()">
      Atendimento Médico - ({{ itemMedicalCare.medicalCare.userName }} - {{
      itemMedicalCare.medicalCare.datetimeInclusion | date:'dd/MM/yy, H:mm' }})
      <span [ngClass]="{'profile-register-accordion-item-description-expanded': accordionItemModule.expanded}"
        class="profile-register-accordion-item-description">
        Clique para {{ accordionItemModule.expanded ? 'fechar' : 'abrir' }}
      </span>
    </div>
    <div class="profile-register-accordion-item-body" role="region"
      [style.display]="accordionItemModule.expanded ? '' : 'none'" [attr.id]="'accordion-body-' + index"
      [attr.aria-labelledby]="'accordion-header-' + index">
      <div class="feature-content">
        @if (itemMedicalCare.medicalEvolution) {
          <div class="row">
            <div class="col-12">
              <mat-form-field appearance="outline" class="outline-spinner">
                <mat-label>CID</mat-label>
                <textarea matInput readonly [value]="itemMedicalCare.cid.join(', ')"></textarea>
              </mat-form-field>
            </div>
          </div>
        }
        @if (itemMedicalCare.medicalEvolution) {
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12">
              <mat-form-field appearance="outline">
                <mat-label>Anotações médicas (queixas, história da doença atual, medicamentos em uso, história
                pregressa)</mat-label>
                <textarea matInput readonly value="{{itemMedicalCare.medicalCare.medicalNotes}}"></textarea>
              </mat-form-field>
            </div>
          </div>
        }
        @if (itemMedicalCare.medicalEvolution) {
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12">
              <div class="mat-form-field">
                <div class="mat-form-field-label"  [ngClass]="{ 'field-with-value': itemMedicalCare.medicalCare.physicalExamination, 'field-without-value':  !itemMedicalCare.medicalCare.physicalExamination}">
                  <label class="mat-label">Exame físico</label>
                </div>
                <div class="mat-form-field-infix">
                  <div class="mat-input-value">
                    <quill-view-html [content]="itemMedicalCare.medicalCare.physicalExamination" theme="snow"></quill-view-html>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (itemMedicalCare.medicalEvolution) {
          <div class="row">
            <div class="mat-form-field">
              <div class="mat-form-field-label"  [ngClass]="{ 'field-with-value': itemMedicalCare.medicalCare.therapeuticPlan, 'field-without-value':  !itemMedicalCare.medicalCare.therapeuticPlan}">
                <label class="mat-label">Plano Terapêutico</label>
              </div>
              <div class="mat-form-field-infix">
                <div class="mat-input-value">
                  <quill-view-html [content]="itemMedicalCare.medicalCare.therapeuticPlan" theme="snow"></quill-view-html>
                </div>
              </div>
            </div>
          </div>
        }
        @if (itemMedicalCare.medicalEvolution) {
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12">
              <mat-form-field appearance="outline">
                <mat-label>Hipótese Diagnóstica</mat-label>
                <textarea matInput readonly
                value="{{itemMedicalCare.medicalCare.diagnosedHypothesis}}"></textarea>
              </mat-form-field>
            </div>
          </div>
        }
        <div class="row">
          <div class="col-6 col-sm-3 col-md-2">
            <mat-form-field appearance="outline">
              <mat-label>Temperatura</mat-label>
              <input type="number" matInput readonly value="{{itemMedicalCare.medicalCare.temperature}}">
              <span matSuffix>ºC</span>
            </mat-form-field>
          </div>
          <div class="col-6 col-sm-3 col-md-2">
            <mat-form-field appearance="outline">
              <mat-label>FR</mat-label>
              <input type="number" matInput readonly
                value="{{itemMedicalCare.medicalCare.respiratoryFrequency}}">
                <span matSuffix>irpm</span>
              </mat-form-field>
            </div>
            <div class="col-6 col-sm-3 col-md-2">
              <mat-form-field appearance="outline">
                <mat-label>FC</mat-label>
                <input type="number" matInput readonly value="{{itemMedicalCare.medicalCare.heartRate}}">
                <span matSuffix>bpm</span>
              </mat-form-field>
            </div>
            <div class="col-6 col-sm-3 col-md-2">
              <mat-form-field appearance="outline">
                <mat-label>GC</mat-label>
                <input type="number" matInput readonly value="{{itemMedicalCare.medicalCare.glucose}}">
                <span matSuffix>mg/dL</span>
              </mat-form-field>
            </div>
            <div class="col-6 col-sm-3 col-md-2">
              <mat-form-field appearance="outline">
                <mat-label>PA</mat-label>
                <input type="text" matInput readonly
                  value="{{itemMedicalCare.medicalCare.bloodPressureSystole && itemMedicalCare.medicalCare.bloodPressureDiastole ? itemMedicalCare.medicalCare.bloodPressureSystole + '/' + itemMedicalCare.medicalCare.bloodPressureDiastole : null}}">
                  <span matSuffix>mmHG</span>
                </mat-form-field>
              </div>
              <div class="col-6 col-sm-3 col-md-2">
                <mat-form-field appearance="outline">
                  <mat-label>SatO2</mat-label>
                  <input type="number" matInput readonly value="{{itemMedicalCare.medicalCare.saturation}}">
                  <span matSuffix>%</span>
                </mat-form-field>
              </div>
            </div>
            <div class="title-header">
              <h4>Isolamento e Atestado</h4>
            </div>
            <div class="row">
              <div class="col-2 col-sm-2 col-md-2">
                <mat-slide-toggle [disabled]="true" class="indigent-checkbox" [ngModelOptions]="{standalone: true}" [checked]="itemMedicalCare.medicalCare.datetimeEndIsolation">Isolamento</mat-slide-toggle>
              </div>
              <div class="col-6 col-sm-3 col-md-2">
                <mat-form-field appearance="outline">
                  <mat-label>Último dia de Isolamento</mat-label>
                  <input matInput readonly [matDatepicker]="isolationDatePicker" value="{{itemMedicalCare.medicalCare.datetimeEndIsolation}}">
                </mat-form-field>
              </div>
              <div class="col-6 col-sm-3 col-md-2">
                <mat-form-field appearance="outline">
                  <mat-label>Dias de atestado</mat-label>
                  <input type="number" matInput readonly value="{{itemMedicalCare.medicalCare.sickDaysOffAmount}}">
                  <span matSuffix>dias</span>
                </mat-form-field>
              </div>
            </div>
            @if (itemMedicalCare.showButtonMedicineSuspended) {
              <div class="action-prescription-content">
                <div class="col-12 col-md-4">
                  <button mat-flat-button type="button" (click)="openPrescriptionsSuspensionModal(itemMedicalCare.medicalCare.idMedicalCare)"
                    color="accent" class=" btn-block">
                    @if (!isLoadingCancelar) {
                      <span>Visualizar itens suspensos</span>
                    }
                    @if (isLoadingCancelar) {
                      <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                    }
                  </button>
                </div>
              </div>
            }
            @if (itemMedicalCare.listInternalPrescription != null && itemMedicalCare.listInternalPrescription.length > 0) {
              <div class="card-list">
                <div class="title-header">
                  <h4>Lista de Prescrições Internas</h4>
                </div>
                <div class="row">
                  @for (item of itemMedicalCare.listInternalPrescription; track item) {
                    <div class="col-12 col-sm-6 col-md-4">
                      <div class="card-item" matTooltip="Observação: {{item.prescriptionMedicine.observation}}">
                        <span [ngClass]="{'text-tacked': item.prescriptionMedicine.idPrescriptionStatus == this.prescriptionStatusEnum.Suspenso}" class="primary">{{item.medicineName}}</span>
                        <div class="tag-container">
                          @for (tag of medicineTagUtilsService.getMainTags(item.listTags); track tag) {
                                    <span class="tag-header-prescription" [ngStyle]="tag.colorCode ? {'background-color': tag.colorCode, 
                                        'color': 'white' } : {}">{{tag.tagName}}</span>
                          }
                          @if (medicineTagUtilsService.getExtraTags(item.listTags).length > 0) {
                            <span class="tag-header-prescription more-tags"
                              matTooltip="{{ medicineTagUtilsService.getTooltipText(item.listTags) }}" matTooltipClass="tag-tooltip">
                              +{{ medicineTagUtilsService.getExtraTags(item.listTags).length }}
                            </span>
                          }
                        </div>
                        <div class="infos">
                          <span class="secundary">Uso: {{item.usage}}</span>
                          <span class="secundary">Via: {{item.administrationTypeName}}</span>
                          <span class="secundary">Apresentação: {{item.presentationName}}</span>
                          <span class="secundary">Frequência: {{item.frequencyName}}</span>
                          <span class="secundary">Periodo trat.: {{item.treatmentPeriodName}}</span>
                          @if (item.motiveSuspended) {
                            <span [matTooltip]="item.motiveSuspended" class="secundary">Motivo da suspensão: {{item.motiveSuspended | truncateText:50}}</span>
                          }
                          @if (item.medicNameSuspended || item.nurseNameSuspended) {
                            <span class="secundary">
                              Responsável pela suspensão: {{item.medicNameSuspended ? item.medicNameSuspended : item.nurseNameSuspended}}; {{ item.prescriptionMedicine.datetimeSuspended | date:'dd/MM/yyyy HH:mm' }}
                            </span>
                          }
                        </div>
                        <div class="actions">
                          <a>
                            <mat-icon aria-hidden="false" aria-label="Ver mais"
                            (click)="openPrecriptionModalWithMedicine(item)">visibility</mat-icon>
                          </a>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            @if (itemMedicalCare.medicalEvolution && itemMedicalCare.listPrescriptionSolution != null && itemMedicalCare.listPrescriptionSolution.length > 0) {
              <div class="sub-section"
                >
                <div class="title-header">
                  <h4>Solução medicamentosa</h4>
                </div>
              </div>
            }
            @if (itemMedicalCare.medicalEvolution && itemMedicalCare.listPrescriptionSolution != null && itemMedicalCare.listPrescriptionSolution.length > 0) {
              <div class="card-list"
                >
                <div class="row row-list">
                  @for (item of itemMedicalCare.listPrescriptionSolution; track item; let index = $index) {
                    <div class="col-12 col-sm-6 col-md-4"
                      >
                      <div class="card-item">
                        <div class="infos">
                          @for (medicine of item.listSolutionMedicine; track medicine; let indexMedicine = $index) {
                            <div>
                              <span [ngClass]="{'text-tacked': item.idPrescriptionStatus == this.prescriptionStatusEnum.Suspenso}" class="primary">{{medicine.medicineName}}</span>
                              <div class="tag-container">
                                @for (tag of medicineTagUtilsService.getMainTags(medicine.listTags); track tag) {
                                            <span class="tag-header-prescription" [ngStyle]="tag.colorCode ? {'background-color': tag.colorCode, 
                                                'color': 'white' } : {}">{{tag.tagName}}</span>
                                }
                                @if (medicineTagUtilsService.getExtraTags(medicine.listTags).length > 0) {
                                  <span class="tag-header-prescription more-tags"
                                    matTooltip="{{ medicineTagUtilsService.getTooltipText(medicine.listTags) }}" matTooltipClass="tag-tooltip">
                                    +{{ medicineTagUtilsService.getExtraTags(medicine.listTags).length }}
                                  </span>
                                }
                              </div>
                            </div>
                          }
                          <span class="secundary">Uso: {{item.usage}}</span>
                          <span class="secundary">Via: {{item.administrationTypeName}}</span>
                          <span class="secundary">Apresentação: {{item.presentationName}}</span>
                          <span class="secundary">Frequência: {{item.frequencyName}}</span>
                          <span class="secundary">Periodo trat.: {{item.treatmentPeriodName}}</span>
                          @if (item.motiveSuspended) {
                            <span [matTooltip]="item.motiveSuspended" class="secundary">Motivo da suspensão: {{item.motiveSuspended | truncateText:50}}</span>
                          }
                          @if (item.medicNameSuspended || item.nurseNameSuspended) {
                            <span class="secundary">
                              Responsável pela suspensão: {{item.medicNameSuspended ? item.medicNameSuspended : item.nurseNameSuspended}}; {{ item.datetimeSuspended | date:'dd/MM/yyyy HH:mm' }}
                            </span>
                          }
                        </div>
                        <div class="actions">
                          <a>
                            <mat-icon aria-hidden="false" aria-label="Ver mais"
                            (click)="openPrecriptionModalWithMedicatedSolution(item)">visibility</mat-icon>
                          </a>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            @if (itemMedicalCare.listExternalPrescription != null && itemMedicalCare.listExternalPrescription.length > 0) {
              <div class="card-list">
                <div class="title-header">
                  <h4>Lista de Prescrições Externas</h4>
                </div>
                <div class="row">
                  @for (item of itemMedicalCare.listExternalPrescription; track item) {
                    <div class="col-12 col-sm-6 col-md-4">
                      <div class="card-item">
                        <div class="infos">
                          <span class="primary">{{item.description}}</span>
                          <span class="secundary">Quantidade: {{item.quantity}}</span>
                          <span class="secundary">Apresentação: {{item.presentationName}}</span>
                          <span class="secundary">Frequência: {{item.frequency}}</span>
                          <span class="secundary">Observação: {{item.observation}}</span>
                        </div>
                        <div class="actions">
                          <a>
                            <mat-icon aria-hidden="false" aria-label="Ver mais"
                            (click)="openExternalPrescriptionModal(item)">visibility</mat-icon>
                          </a>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            @if (itemMedicalCare.listPrescriptionNonStandard != null && itemMedicalCare.listPrescriptionNonStandard.length > 0) {
              <div class="card-list">
                <div class="title-header">
                  <h4>Lista de Prescrições Não Padronizadas</h4>
                </div>
                <div class="row row-list">
                  @for (item of itemMedicalCare.listPrescriptionNonStandard; track item; let index = $index) {
                    <div class="col-12 col-sm-6 col-md-4"
                      >
                      <div class="card-item">
                        <div class="infos">
                          <quill-view-html [content]="item.formattedText" theme="snow"></quill-view-html>
                        </div>
                        <div class="actions">
                          <a>
                            <mat-icon aria-hidden="false" aria-label="Ver mais"
                            (click)="openPrescriptionNonStandardModal(item)">visibility</mat-icon>
                          </a>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            @if (itemMedicalCare.listMemedPrescriptionStruct != null && itemMedicalCare.listMemedPrescriptionStruct.length > 0) {
              <div class="card-list">
                <div class="title-header">
                  <h4>Lista de Prescrições Memed</h4>
                </div>
                <div class="row row-list">
                  @for (item of itemMedicalCare.listMemedPrescriptionStruct; track item; let index = $index) {
                    <div class="col-12 col-sm-6 col-md-5"
                      >
                      <div class="card-item">
                        <div class="infos">
                          @for (medicine of item.listMemedMedicine; track medicine; let indexMedicine = $index) {
                            <div class="memed-prescription-info">
                              <span class="primary">{{indexMedicine + 1}} - {{medicine.name}}</span>
                              <span class="secundary">Quantidade: {{medicine.quantity}}</span>
                              <span class="secundary">Unidade: {{medicine.unit}}</span>
                            </div>
                          }
                        </div>
                        <!-- <div class="actions">
                        <a>
                        </a>
                      </div> -->
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (itemMedicalCare.medicalProcedure != null && itemMedicalCare.medicalProcedure.length > 0) {
            <div class="card-list">
              <div class="title-header">
                <h4>Lista de Procedimentos </h4>
              </div>
              <div class="row">
                @for (item of itemMedicalCare.medicalProcedure; track item) {
                  <div class="col-12 col-sm-6 col-md-4">
                    @if (item.idMedicalCare != null) {
                      <div class="card-item">
                        <div class="infos">
                          <span class="primary">{{item.procedureName}}</span>
                          <span class="secundary">Observação do médico: {{item.observation}}</span>
                          <span class="secundary">Solicitação: {{item.userName}}</span>
                        </div>
                        <div class="actions">
                          <a>
                            <mat-icon aria-hidden="false" aria-label="Ver mais"
                            (click)="openProcedureModal(item)">visibility</mat-icon>
                          </a>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          @if (itemMedicalCare.showButtonExamSuspended) {
            <div class="action-prescription-content">
              <div class="col-12 col-md-4">
                <button mat-flat-button type="button" (click)="openExamsSuspensionModal(itemMedicalCare.medicalCare.idMedicalCare)"
                  color="accent" class=" btn-block">
                  @if (!isLoadingCancelar) {
                    <span>Visualizar exames suspensos</span>
                  }
                  @if (isLoadingCancelar) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                  }
                </button>
              </div>
            </div>
          }
          @if (itemMedicalCare.medicalCareSadt != null && itemMedicalCare.medicalCareSadt.length > 0) {
            <div class="card-list">
              <div class="title-header">
                <h3>Lista de Exames</h3>
              </div>
              <div class="row">
                @for (item of itemMedicalCare.medicalCareSadt; track item) {
                  <div class="col-12 col-sm-6 col-md-4">
                    <div class="card-item">
                      <div class="infos">
                        <span [ngClass]="{'text-tacked': item.idStatus == this.sadtStatusEnum.Suspenso}" class="primary">{{item.typeSadtName}}</span>
                        <span class="secundary" [ngClass]="{'exame-entregue': item.idStatus == 2}">{{item.statusName}}</span>
                        <span class="secundary">{{item.placeName}}</span>
                        <span class="secundary">{{item.datetimeInclusion | date:'dd/MM/yy, H:mm'}}</span>
                        @if (item.motiveSuspended) {
                          <span [matTooltip]="item.motiveSuspended" class="secundary">Motivo da suspensão: {{item.motiveSuspended | truncateText:50}}</span>
                        }
                        @if (item.medicNameSuspended || item.nurseNameSuspended) {
                          <span class="secundary" [matTooltip]="(item.medicNameSuspended ? item.medicNameSuspended : item.nurseNameSuspended) + '; ' + (item.datetimeSuspended | date:'dd/MM/yyyy HH:mm')">
                            Responsável pela suspensão: {{item.medicNameSuspended ? item.medicNameSuspended : item.nurseNameSuspended}}; {{ item.datetimeSuspended | date:'dd/MM/yyyy HH:mm' }}
                          </span>
                        }
                      </div>
                      <div class="actions">
                        <a>
                          <mat-icon aria-hidden="false" aria-label="Ver mais"
                          (click)="openSadtModal(item)">visibility</mat-icon>
                        </a>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </cdk-accordion-item>
  }